const AUTH_ONLY_PATHS = new Set([
  '/',
  '/auth',
  '/signin',
  '/signup',
  '/sign-in',
  '/sign-up',
  '/login-support',
  '/reset-password',
  '/forgot-password',
  '/update-password',
  '/onboarding',
]);

export const normalizeKindredReturnTo = (value: string | null | undefined) => {
  if (!value) return null;

  const trimmed = value.trim();
  if (!trimmed.startsWith('/') || trimmed.startsWith('//')) {
    return null;
  }

  try {
    const parsed = new URL(trimmed, 'https://kindredcommunity.app');
    if (parsed.origin !== 'https://kindredcommunity.app' || AUTH_ONLY_PATHS.has(parsed.pathname)) {
      return null;
    }

    return `${parsed.pathname}${parsed.search}${parsed.hash}`;
  } catch {
    return null;
  }
};

export const buildKindredAuthPath = (
  authPath: '/signin' | '/signup' | '/sign-in' | '/sign-up',
  returnTo: string | null | undefined,
) => {
  const safeReturnTo = normalizeKindredReturnTo(returnTo);
  return safeReturnTo
    ? `${authPath}?returnTo=${encodeURIComponent(safeReturnTo)}`
    : authPath;
};
